import React, { Component } from 'react'
import VULogoAllWhiteDiamond from '../../static/img/logos/vu_logo_melb_white_diamond.svg'
import { getHelperTextForPage } from '../../services/reservoir'
import { getSonePersonalDetails } from '../../services/vu'
import { getProperty } from '../../helpers/properties'
import { getCourseCode } from '../../helpers/course'
import { ArrowForward } from '@mui/icons-material'

export default class ThankYou extends Component {
  constructor(props) {
    super(props)

    this.state = {
      displayName: '',
      // emailConfirmationMessage: '',
      myvuLink: getProperty('myVuSiteUrl'),
      courseId: getCourseCode()
    }
  }

  componentDidMount() {
    // getHelperTextForPage('Thank You').then(helperText => {
    //   this.setState({
    //     emailConfirmationMessage: helperText.data.length > 0 ? helperText.data[0].attributes.body.value : this.state.emailConfirmationMessage
    //   })
    // })
    sessionStorage.removeItem('ONBOARDING_COMPLETE')
    getSonePersonalDetails().then(personalDetails => {
      this.setState({
        displayName: personalDetails.preferredName ? personalDetails.preferredName : personalDetails.firstName
      })
    })
  }

  render() {
    return (
      <div className="page page__thankyou">
        <span>
          <img className="vu-logo" alt="Victoria University logo" src={VULogoAllWhiteDiamond} />
        </span>

        <h1>{`Thanks${this.state.displayName ? ` ${this.state.displayName}` : ''}`}</h1>

        <div className="content-container">
          <p className="txt-lg">Congratulations, you have successfully enrolled!</p>
        </div>
        <div className="next-steps">
          <p>
            <strong>Next steps:</strong> Check out <b>MyVU</b> to access your weekly guide, student tools and more!
          </p>

          <a href={this.state.myvuLink + '?courseId=' + this.state.courseId} className="btn btn-primary btn-lg navigation-complete">
            Go to <b>MyVU</b> <ArrowForward className="btn-point-events" />
          </a>
        </div>
      </div>
    )
  }
}
